import UserTrackingAPI from '~/api/userTrackingApi';

function setCookie(name, value, days){
    const expires = new Date(Date.now()+days*86400000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name){
    const value=`; ${document.cookie}`;
    const parts=value.split(`; ${name}=`);
    if(parts.length===2) return parts.pop().split(";").shift();
    return null;
}

async function sha256(message){
    const msgBuffer=new TextEncoder().encode(message);
    const hashBuffer=await crypto.subtle.digest("SHA-256", msgBuffer);
    return btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
}

async function trackVisitor(){
    let clientId = getCookie("ClientId");
    if(!clientId){
        clientId = crypto.randomUUID();
        setCookie("ClientId", clientId, 730);
    }
    const deviceHash = await sha256(navigator.userAgent + "|" + navigator.language);
    const params = {
        ClientId : clientId,
        DeviceHash: deviceHash,
        UserAgent: navigator.userAgent,
        Referrer: document.referrer || ""
    }
    UserTrackingAPI.trackVisitor(params).catch((err) => {
        ;
    });
    return clientId;
}

async function startSession(clientId){
    const sessionId=crypto.randomUUID();
    sessionStorage.setItem("sessionId",sessionId);
    const params = {
        ClientId : clientId,
        SessionId : sessionId
    }
    UserTrackingAPI.startSession(params).catch((err) => {
        ;
    });
    return sessionId;
}

async function endSession(){
    const sessionId=sessionStorage.getItem("sessionId");
    const params = {
        SessionId : sessionId
    }
    UserTrackingAPI.endSession(params).catch((err) => {
        ;
    });
}

async function trackPageView(clientId, sessionId){
    const params = {
        ClientId : clientId,
        SessionId : sessionId,
        PageUrl: window.location.pathname,
        Referrer:document.referrer
    }
    UserTrackingAPI.pageView(params).catch((err) => {
        ;
    });
}

export {setCookie, getCookie, sha256, trackVisitor, startSession, endSession, trackPageView};